import { Header } from '@/components/ActionSheet';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

export const NarrativeFairValueHeader = ({ children }: Props) => {
  return (
    <div className="-mx-2 pb-4 sm:px-1 lg:px-5">
      <Header>
        <div className="text-base font-strong text-solid">{children}</div>
      </Header>
    </div>
  );
};
